import { observer } from 'mobx-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { PlaceItem } from '..';
import { PlaceCategoryInterface } from '../../interfaces_and_types';
import ItemsCategory from '../../interfaces_and_types/placeItemsCategoryType';
import Item from '../../interfaces_and_types/placeItemType';
import './styles.css';
import { v4 as uuidv4 } from 'uuid';
const isCategory = (prop: ItemsCategory | Item): prop is ItemsCategory => {
  return (prop as ItemsCategory).items !== undefined;
};

const PlaceCategory = (props: PlaceCategoryInterface) => {
  const {t} = useTranslation()
  return (
    <div className='place-category'>
      <h2 className='place-category-title'>{t(props.category.title)}</h2>
      <div className='place-category-items-container'>
        {isCategory(props.category)
          ? props.category.items.map((item) => (
              <PlaceItem
                key={uuidv4()}
                item={item}
                categoryID={props.category.id}
              />
            ))
          : props.category.subItemsCategories?.map((subItemsCategory) =>
              subItemsCategory.subItems.map((subItem) => (
                <PlaceItem
                  key={uuidv4()}
                  item={subItem}
                  categoryID={subItemsCategory.id}
                />
              ))
            )}
      </div>
    </div>
  );
};

export default observer(PlaceCategory);
